export default function initLoader() {
  const loader = document.getElementById('loader');

  if (loader) {
    const duration = 100;

    document.addEventListener('readystatechange', (event) => {
      setTimeout(() => {
        loader.classList.add('d-none');

        // Force page scroll position to top
        window.scrollTo(0, 0);
      }, duration);
    });
  }
}
